import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import { AuthProvider } from "./shared/auth/AuthContext";
import "./index.css";

const pageBackground = import.meta.env.VITE_PAGE_BACKGROUND?.trim();

if (pageBackground) {
  document.documentElement.style.setProperty("--page-background", pageBackground);
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
